<template>
<div>
  <section class="subHeaderConfig">
    <XCerrar/>
    <div class="gestion"><h4>{{ nivelPrevio }} </h4></div>
    <h2>{{ nombreGestion }}</h2>
  </section>
</div>
</template>

<script>
import XCerrar from '../components/XCerrar.vue'
export default {
  components: { XCerrar },
  name: 'SubHeaderConfig',
  props: ['nombreGestion', 'nivelPrevio']
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
section.subHeaderConfig {
  height: 8vh;
  background-color: var(--az-me-tr07);
  color: rgb(255, 255, 255);
  display: grid;
  grid-template-columns: 1fr 80vw;
  align-items:center;
  justify-items: left;
}
.subHeaderConfig{
  z-index: 10;
  box-shadow: rgb(2, 2, 2) 0px 0px 15px;
  position: relative;
}
section.subHeaderConfig h2 {
  font-weight: bold;
  color: var(--na);
  padding-left: 0px;
}
.gestion{
  display:flex;
  justify-self: right;
  padding-right: 2%;
}
section.subHeaderConfig h4 {
  font-weight: lighter;
  color: rgb(255, 255, 255);
}
@media screen and (max-width: 575px){
  .gestion {
    display: none;
  }
  section.subHeaderConfig {
  display: flex;
  /* align-items:center;
  justify-items: left; */
}
  section.subHeaderConfig h2 {
    padding-left: 4vw;
    text-align: left;
    font-weight: 200;
  }
}
</style>
